import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { LiveTracker } from 'src/domains/sportsbook/webview/components/scoreboards/liveTracker/LiveTracker';
import { LSportWrapper } from 'src/domains/sportsbook/webview/components/scoreboards/lSport/lSport';
import { Scoreboards } from 'src/domains/sportsbook/webview/components/scoreboards/Scoreboards';
import { ImgArena } from 'src/domains/sportsbook/webview/components/scoreboards/imgArena/ImgArena';
import { GeniusWidgets } from 'src/domains/sportsbook/webview/components/scoreboards/genius/GeniusWidgets';
import { getGeniusWidgetConfig } from 'src/domains/sportsbook/webview/components/scoreboards/genius/getGeniusWidgetConfig';
import { GeniusLivePlayer } from 'src/domains/sportsbook/webview/components/stream/genius';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { MatchLeadContainer } from './MatchLead.style';

interface MatchLeadPropsType {
    event: EventModel | null;
}

export const MatchLead = observer('MatchLead', ({ event }: MatchLeadPropsType) => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;

    const eventId = event?.id2.toOldId() ?? null;
    const shouldMountGenius =
        event !== null &&
        config.geniusStreamingEnabled === true &&
        common.session.isAuthorized === true &&
        event.timeMatchInPlay === true;

    if (event === null || eventId === null) {
        return null;
    }

    const hasGeniusWidget = getGeniusWidgetConfig(event, config) !== null;

    return (
        <MatchLeadContainer>
            {shouldMountGenius ? (
                <GeniusLivePlayer
                    key={eventId}
                    eventId={eventId}
                />
            ) : null}

            {/* Basic / animated scoreboards — hidden when Genius widget is shown */}
            {hasGeniusWidget === false ? <Scoreboards event={event} /> : null}

            {/* Genius Scoreboard / Game Tracker */}
            <GeniusWidgets event={event} />

            {/* LSport now is Statscore scoreboard */}
            <LSportWrapper
                sport={event.sport}
                lsportExternalId={event.lsportExternalId}
                timeSettingsStarted={event.timeSettingsStarted}
            />

            {/* Live Tracker from Planetsport with animation */}
            {event.template === 'outrights' ? null : (
                <LiveTracker
                    sport={event.sport}
                    eventId={eventId}
                    isOpen={event.timeMatchInPlay}
                />
            )}

            {/* Img arena live tracer */}
            <ImgArena
                sport={event.sport}
                eventFeedGroupId={event.feedGroupId} // hardcoded event for stg testing: '644'
                eventId={eventId}
            />
        </MatchLeadContainer>
    );
});
